module.exports = __webpack_public_path__ + "img/HeaderBaner.095af598.png";